import { useState } from "react";
import { Loader2, FolderOpen, PieChart } from "lucide-react";
import { Model } from "../components/site/ModelNetwork";
import { Header } from "../components/site/Header";
import { Footer } from "../components/site/Footer";
import { useAuth } from "../context/AuthContext";
import { useLang } from "../i18n/LangContext";
import { ProGate } from "../components/pro/ProGate";
import { ExpertMissions } from "../components/pro/ExpertMissions";
import { ChangePassword } from "../components/account/AccountSecurity";
import { ClientAcademyRequests } from "../components/pro/ClientAcademyRequests";
import { Matching } from "../components/pro/Matching";

const Dossier = () => {
  const { user } = useAuth();
  if (user === undefined) return <Loader2 className="spin" aria-label="Loading" />;
  if (user?.role === "expert") {
    return (
      <>
        <ProGate tab="expert" standalone />
        <div style={{ marginTop: 20 }}><ExpertMissions /></div>
      </>
    );
  }
  if (user?.role === "client") {
    return (
      <>
        <ProGate tab="client" standalone />
        <div style={{ marginTop: 20 }}><ClientAcademyRequests /></div>
        <div style={{ marginTop: 20 }}><Matching /></div>
      </>
    );
  }
  return <ProGate tab="client" standalone />;
};

const SpaceTabs = ({ tab, setTab }) => {
  const { t } = useLang();
  return (
    <div className="tabs" role="tablist" aria-label={t.dossier.eyebrow}>
      {[["dossier", FolderOpen], ["model", PieChart]].map(([k, Icon]) => (
        <button key={k} type="button" role="tab" className="tab-btn" aria-selected={tab === k} onClick={() => setTab(k)} data-testid={`space-tab-${k}`}>
          <Icon aria-hidden="true" />{t.dossier.tabs[k]}
        </button>
      ))}
    </div>
  );
};

export default function ProPage() {
  const { t } = useLang();
  const { user } = useAuth();
  const [tab, setTab] = useState("dossier");
  const showModel = Boolean(user?.role);
  const title = user?.role === "expert" ? t.dossier.expertTitle : user?.role === "client" ? t.dossier.clientTitle : t.pro.title;
  return (
    <>
      <Header />
      <main id="main" className="section pro-page" data-testid="pro-page">
        <div className="wrap">
          <div className="section-head">
            <p className="eyebrow">{t.dossier.eyebrow}</p>
            <h2>{title}</h2>
          </div>
          {showModel && <SpaceTabs tab={tab} setTab={setTab} />}
          {(!showModel || tab === "dossier") && <Dossier />}
          {showModel && tab === "dossier" && (
            <div className="panel pro-panel" style={{ marginTop: 20 }} data-testid="espace-account-security">
              <p className="console-title" style={{ display: "block", marginBottom: 14 }}>{t.account.title}</p>
              <ChangePassword />
            </div>
          )}
        </div>
        {showModel && tab === "model" && <div className="space-model tab-panel"><Model /></div>}
      </main>
      <Footer />
    </>
  );
}
